import { getKitchenBindToken } from '@/utils/kitchenBinding';

const MANIFEST_LINK_ID = 'ollaa-web-manifest-link';
const MANIFEST_PARTNER_HREF = '/manifest.json';
const MANIFEST_KITCHEN_LIVE = '/manifest-kitchen-live.json';
const MANIFEST_LINK_SELECTOR = 'link[rel="manifest"]';
const APPLE_CAPABLE_SELECTOR = 'meta[name="apple-mobile-web-app-capable"]';
const APPLE_TITLE_SELECTOR = 'meta[name="apple-mobile-web-app-title"]';

let kitchenManifestBlobUrl = '';
let kitchenManifestBlobForToken = '';

const revokeKitchenManifestBlob = () => {
  if (kitchenManifestBlobUrl) {
    URL.revokeObjectURL(kitchenManifestBlobUrl);
    kitchenManifestBlobUrl = '';
    kitchenManifestBlobForToken = '';
  }
};

export const buildKitchenManifestObject = (bindToken) => {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const token = String(bindToken || '').trim();
  const startUrl = token
    ? `/kueche?bind=${encodeURIComponent(token)}`
    : '/kueche';
  return {
    name: 'Ollaa Küche',
    short_name: 'Küche',
    icons: [
      {
        src: `${origin}/img/icons/android-chrome-192x192.png`,
        sizes: '192x192',
        type: 'image/png',
      },
      {
        src: `${origin}/img/icons/android-chrome-512x512.png`,
        sizes: '512x512',
        type: 'image/png',
      },
    ],
    start_url: startUrl,
    scope: '/',
    display: 'standalone',
    background_color: '#ffffff',
    theme_color: '#FFFFFF',
    orientation: 'portrait',
  };
};

const resolveKitchenManifestHref = (bindToken) => {
  const token = String(bindToken || '').trim();
  if (!token) return MANIFEST_KITCHEN_LIVE;
  if (token === kitchenManifestBlobForToken && kitchenManifestBlobUrl) {
    return kitchenManifestBlobUrl;
  }
  revokeKitchenManifestBlob();
  kitchenManifestBlobUrl = URL.createObjectURL(
    new Blob([JSON.stringify(buildKitchenManifestObject(token))], {
      type: 'application/manifest+json',
    }),
  );
  kitchenManifestBlobForToken = token;
  return kitchenManifestBlobUrl;
};

/**
 * Küchen-PWA: eigenes Manifest (standalone + start_url mit bind), nie Partner-manifest.json.
 */
export const applyKitchenPwaHead = () => {
  if (typeof document === 'undefined') return;

  const bindToken = getKitchenBindToken();
  const manifestHref = resolveKitchenManifestHref(bindToken);

  let manifestLink = document.getElementById(MANIFEST_LINK_ID)
    || document.querySelector(MANIFEST_LINK_SELECTOR);
  if (!manifestLink) {
    manifestLink = document.createElement('link');
    manifestLink.rel = 'manifest';
    manifestLink.id = MANIFEST_LINK_ID;
    document.head.appendChild(manifestLink);
  }
  if (!manifestLink.dataset.ollaaPartnerHref) {
    manifestLink.dataset.ollaaPartnerHref = MANIFEST_PARTNER_HREF;
  }
  manifestLink.setAttribute('href', manifestHref);

  let appleCapable = document.querySelector(APPLE_CAPABLE_SELECTOR);
  if (!appleCapable) {
    appleCapable = document.createElement('meta');
    appleCapable.setAttribute('name', 'apple-mobile-web-app-capable');
    document.head.appendChild(appleCapable);
  }
  appleCapable.setAttribute('content', 'yes');

  let appleTitle = document.querySelector(APPLE_TITLE_SELECTOR);
  if (!appleTitle) {
    appleTitle = document.createElement('meta');
    appleTitle.setAttribute('name', 'apple-mobile-web-app-title');
    document.head.appendChild(appleTitle);
  }
  appleTitle.setAttribute('content', 'Ollaa Küche');

  document.title = 'Ollaa Küche';
  const titleEl = document.getElementById('ollaa-document-title');
  if (titleEl) titleEl.textContent = 'Ollaa Küche';
};

export const restorePartnerPwaHead = () => {
  if (typeof document === 'undefined') return;

  revokeKitchenManifestBlob();

  let manifestLink = document.getElementById(MANIFEST_LINK_ID)
    || document.querySelector(MANIFEST_LINK_SELECTOR);
  if (!manifestLink) {
    manifestLink = document.createElement('link');
    manifestLink.rel = 'manifest';
    manifestLink.id = MANIFEST_LINK_ID;
    document.head.appendChild(manifestLink);
  }
  const href = manifestLink.dataset?.ollaaPartnerHref || MANIFEST_PARTNER_HREF;
  manifestLink.setAttribute('href', href);

  const appleCapable = document.querySelector(APPLE_CAPABLE_SELECTOR);
  if (appleCapable) appleCapable.remove();

  const appleTitle = document.querySelector(APPLE_TITLE_SELECTOR);
  if (appleTitle) appleTitle.setAttribute('content', 'Ollaa Partner');
};
